import { render } from "./EditDashboardTileModal.vue?vue&type=template&id=073d26b8&scoped=true"
import script from "./EditDashboardTileModal.vue?vue&type=script&lang=js"
export * from "./EditDashboardTileModal.vue?vue&type=script&lang=js"

import "./EditDashboardTileModal.vue?vue&type=style&index=0&id=073d26b8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-073d26b8"]])

export default __exports__